const COMPARE_LIST_KEY = 'compareList'

function addProductToCompare(productData) {
	let compareList = getCompareProducts()
	if (!compareList.some((p) => p.handle === productData?.handle)) {
		compareList.push(productData)
		localStorage.setItem(COMPARE_LIST_KEY, JSON.stringify(compareList))
	}

	// Update header compare icon
	checkCompareListActive()
}

function removeProductFromCompare(productHandle) {
	let compareList = getCompareProducts()
	compareList = compareList.filter((p) => p?.handle !== productHandle)
	localStorage.setItem(COMPARE_LIST_KEY, JSON.stringify(compareList))

	// Update header compare icon
	checkCompareListActive()
}

function getCompareProducts() {
	return JSON.parse(localStorage.getItem(COMPARE_LIST_KEY)) || []
}

function doesCompareProductExist(productHandle) {
	const compareList = getCompareProducts()
	const isExist = compareList.some((p) => p?.handle === productHandle)
	return isExist
}

function clearCompareList() {
	localStorage.removeItem(COMPARE_LIST_KEY)
}

window.checkCompareListActive = function checkCompareListActive() {
	const compareList = getCompareProducts()
	const headerIconWrapper = document.querySelector('.header__icon--compare')
	if (compareList.length > 0) {
		headerIconWrapper?.classList.add('active')
	} else {
		headerIconWrapper?.classList.remove('active')
	}
}

async function fetchProductInfo(productHandle) {
	const response = await fetch(`${Shopify.routes.root}products/${productHandle}.js`)
	if (response.ok) {
		return await response.json()
	} else {
		console.error(`Failed to fetch product info for Handle: ${productHandle}`)
		return null
	}
}

async function fetchCompareProducts() {
	const productData = getCompareProducts()
	const productPromises = productData.map(async (product) => {
		const fetchedProduct = await fetchProductInfo(product?.handle)
		return fetchedProduct ? { ...fetchedProduct, metafields: product } : null
	})

	const products = await Promise.all(productPromises)
	return products.filter((product) => product !== null)
}

function toggleCompareArrows() {
	const compareList = getCompareProducts()
	const carouselButtons = document.querySelector(
		'.compare-section .carousel-navigation__container'
	)
	if (compareList.length > 4) {
		carouselButtons?.classList.remove('hidden')
	} else {
		carouselButtons?.classList.add('hidden')
	}
}

function createProductCompareItem(product) {
	const productStyle = product?.tags?.find(tag => tag?.startsWith("hat-style:"))?.split(":")?.[1]
	const productTitle = productStyle || product.title.split(" -")[0];
	const productPrice = (product.price / 100).toLocaleString("en-AU", {
		style: "currency",
		currency: "AUD",
	});
	const productMetafields = product.metafields

	const productMetafieldsData = {
		handle: productMetafields?.productHandle,
		colour: productMetafields?.colour,
		inner: productMetafields?.inner,
		outer: productMetafields?.outer,
		lining: productMetafields?.lining,
		eyelets: productMetafields?.eyelets,
		brim: productMetafields?.brim,
		crown: productMetafields?.crown,
		crown_type: productMetafields?.crown_type,
		binding: productMetafields?.binding,
		category: productMetafields?.category,
		year_created: productMetafields?.year_created,
		similar_style: productMetafields?.similar_style
	}

	// Generate metafields HTML dynamically, excluding "handle" key
	const metafieldsHTML = Object.entries(productMetafieldsData || {})
		.filter(([key, _]) => key !== "handle")  // Exclude handle
		.map(
			([key, value]) => `
			<div class="${value == undefined ? 'hidden' : 'compare-item__info'}">
				<h5 class="compare-item__info-label">${key.replace(/_/g, " ")}</h5>
				<p class="compare-item__info-data">${value}</p>
			</div>
		`
		)
		.join("");

	return `
    	<a href="${product.url}" class="compare-item shrink-0 snap-center group" data-product-handle="${product.handle}">
      		<div class="compare-item__image-wrapper">
        		<img src="${product?.media[1]?.src || product.featured_image}" alt="${product.title}" class="compare-item__image" />
        		<button class="compare-item__remove-button" data-product-handle="${product.handle}">
					<svg aria-hidden="true" focusable="false" fill="none" width="16" viewBox="0 0 16 16">
						<path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1"/>
					</svg>
				</button>
      		</div>
      		
			<h2 class="compare-item__title product-title">${productTitle}</h2>
      
			<div class="compare-item__info">
				<h5 class="compare-item__info-label">Price</h5>
				<p class="compare-item__info-data">${productPrice}</p>
			</div>
      
      		${productMetafieldsData?.colour ? `
        		<div class="compare-item__info">
        			<h5 class="compare-item__info-label">Colour</h5>
        			<p class="compare-item__info-data">${productMetafieldsData?.colour}</p>
      			</div>
			` : ``}

			<div class="compare-item__info">
				<h5 class="compare-item__info-label">Style</h5>
				<p class="compare-item__info-data">${productStyle}</p>
			</div>

			${metafieldsHTML}
    	</a>
  	`
}

window.renderCompareProducts = async function renderCompareProducts() {
	const compareListElement = document.querySelector('.compare-list')
	if (!compareListElement) return null

	compareListElement.innerHTML = '<div class="loading">Loading...</div>'

	const products = await fetchCompareProducts()
	if (products.length === 0) {
		compareListElement.innerHTML = '<div class="empty">To help you find the perfect Akubra, use our compare feature! Simply add hats to the comparison list to see their key details side by side—like inner band, outer band, brim width, crown height, eyelets, binding, and crown type. This makes it easy to spot the differences and choose the right fit for you.</div>'
	} else {
		compareListElement.innerHTML = products.map(createProductCompareItem).join('')

		document.querySelectorAll('.compare-item__remove-button').forEach((button) => {
			button.addEventListener('click', function (e) {
				e.preventDefault()
				const productHandle = this.getAttribute('data-product-handle')
				removeProductFromCompare(productHandle)
				renderCompareProducts()
			})
		})
	}
	toggleCompareArrows()
}

window.addCompareToProductCard = function addCompareToProductCard(alteredProductListCount = 0) {
	const productCards = document.querySelectorAll('.product-card')
	productCards.forEach((card, index) => {
		// Skips product cards that already exist on CLP to stop a second event listener applying
		if (index < alteredProductListCount) return;
		const compareButton = card.querySelector('.product-card__compare-button')
		if (!compareButton) return;
		const productHandle = compareButton.getAttribute('data-product-handle')
		const productMetafields = JSON.parse(compareButton.dataset.productMetafields)

		const productData = {
			handle: productHandle,
			inner: productMetafields?.inner,
			outer: productMetafields?.outer,
			colour: productMetafields?.colour,
			lining: productMetafields?.lining,
			eyelets: productMetafields?.eyelets,
			brim: productMetafields?.brim,
			crown: productMetafields?.crown,
			crown_type: productMetafields?.crown_type,
			binding: productMetafields?.binding,
			category: productMetafields?.category,
			year_created: productMetafields?.year_created,
			similar_style: productMetafields?.similar_style
		};

		if (doesCompareProductExist(productData?.handle)) {
			compareButton.classList.add('compare-button--active')
		}

		if (compareButton) {
			compareButton?.addEventListener('click', function (event) {
				event.preventDefault()

				if (doesCompareProductExist(productData?.handle)) {
					removeProductFromCompare(productData?.handle)
					this.classList.remove('compare-button--active')
				} else {
					addProductToCompare(productData)
					this.classList.add('compare-button--active')
				}
			})
		}
	})
}

document.addEventListener('DOMContentLoaded', () => {
	checkCompareListActive()
	renderCompareProducts()
	addCompareToProductCard()
})

// Reapply event listeners after facet DOM has been replaced (facet:updated fires when ready)
document.addEventListener('facet:updated', function () {
	const productList = document.querySelector(".product-list .product-card .product-card__figure .product-card__media");
	if (productList && productList.querySelectorAll('.hidden').length > 2) {
		checkCompareListActive();
		renderCompareProducts();
		addCompareToProductCard();
	}
});